const LOGO = "https://customer-assets.emergentagent.com/job_exec-hiring/artifacts/4l7749by_Ind-US-logo-png.png";

const NAV_LINKS = [
  { label: 'Home', id: 'home' },
  { label: 'Services', id: 'services' },
  { label: 'Industries', id: 'industries' },
  { label: 'Our Process', id: 'process' },
  { label: 'Team', id: 'team' },
  { label: 'Contact', id: 'contact' },
];

export default function Footer() {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <footer className="bg-[#0A1628] pt-16 pb-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Top row */}
        <div className="grid lg:grid-cols-3 gap-12 pb-12 border-b border-white/10">
          {/* Brand */}
          <div>
            <div className="bg-[#0A1628] border border-white/10 inline-block px-3 py-2 mb-6 rounded-sm">
              <img src={LOGO} alt="IndUS Target" className="h-10 w-auto" />
            </div>
            <p className="text-white/45 text-sm leading-relaxed max-w-xs" style={{ fontFamily: '"Inter", sans-serif' }}>
              Execution-first hiring partner for high-growth companies in tech, fintech, and life sciences.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <div className="text-xs font-semibold text-white/40 uppercase tracking-[0.2em] mb-5" style={{ fontFamily: '"Inter", sans-serif' }}>
              Navigation
            </div>
            <ul className="space-y-3">
              {NAV_LINKS.map(({ label, id }) => (
                <li key={id}>
                  <button
                    onClick={() => scrollTo(id)}
                    className="text-sm text-white/55 hover:text-white transition-colors duration-200"
                    style={{ fontFamily: '"Inter", sans-serif' }}
                    data-testid={`footer-link-${id}`}
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <div className="text-xs font-semibold text-white/40 uppercase tracking-[0.2em] mb-5" style={{ fontFamily: '"Inter", sans-serif' }}>
              Contact
            </div>
            <div className="space-y-4">
              <div>
                <div className="text-xs text-white/30 uppercase tracking-wide mb-1" style={{ fontFamily: '"Inter", sans-serif' }}>Email</div>
                <a
                  href="mailto:workwithus@targethr.us"
                  className="text-sm text-white/70 hover:text-[#E8500A] transition-colors duration-200"
                  style={{ fontFamily: '"Inter", sans-serif' }}
                  data-testid="footer-email"
                >
                  workwithus@targethr.us
                </a>
              </div>
              <div>
                <div className="text-xs text-white/30 uppercase tracking-wide mb-1" style={{ fontFamily: '"Inter", sans-serif' }}>Headquarters</div>
                <p className="text-sm text-white/70" style={{ fontFamily: '"Inter", sans-serif' }}>Dallas, Texas</p>
              </div>
              <div>
                <div className="text-xs text-white/30 uppercase tracking-wide mb-1" style={{ fontFamily: '"Inter", sans-serif' }}>Website</div>
                <a
                  href="https://www.targethr.us"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-white/70 hover:text-[#E8500A] transition-colors duration-200"
                  style={{ fontFamily: '"Inter", sans-serif' }}
                  data-testid="footer-website"
                >
                  www.targethr.us
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom row */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/25" style={{ fontFamily: '"Inter", sans-serif' }}>
            &copy; {new Date().getFullYear()} IndUS Target LLC. All rights reserved.
          </p>
          <p className="text-xs text-white/25" style={{ fontFamily: '"Inter", sans-serif' }}>
            Recruitment & Placement Professionals · Dallas, TX
          </p>
        </div>
      </div>
    </footer>
  );
}
